if (!customElements.get('complementary-selection')) {
  customElements.define('complementary-selection', class ComplementarySelection extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.scope = this.closest('.product__info-container');
      if (!this.scope) return;
      const options = { signal: this.controller.signal };
      this.scope.addEventListener('change', (event) => this.onChange(event), options);
      this.scope.addEventListener('input', (event) => {
        if (event.target.matches('[name="quantity"]')) this.updateTotal();
      }, options);
      this.priceObserver = new MutationObserver(() => this.updateTotal());
      const price = this.scope.querySelector('[id^="price-"]');
      if (price) this.priceObserver.observe(price, { childList: true, subtree: true });
      this.loadRecommendations();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.priceObserver?.disconnect();
      this.toggleCheckout(false);
      this.controller = null;
    }

    async loadRecommendations() {
      try {
        const response = await fetch(this.dataset.url, { signal: this.controller.signal });
        if (!response.ok) throw new Error('Recommendations unavailable');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const source = html.getElementById(this.id);
        if (!source?.querySelector('[data-complementary-item]')) return;
        this.innerHTML = source.innerHTML;
        this.hidden = false;
        this.updateTotal();
      } catch (error) {
        if (error.name !== 'AbortError') console.error(error);
      }
    }

    onChange(event) {
      if (event.target.matches('[data-complementary-variant]')) {
        const row = event.target.closest('[data-complementary-item]');
        const option = event.target.selectedOptions[0];
        const checkbox = row.querySelector('[data-complementary-checkbox]');
        checkbox.dataset.variantId = option.value;
        checkbox.dataset.price = option.dataset.price;
        checkbox.dataset.quantity = option.dataset.quantity;
        row.querySelector('[data-complementary-price]').textContent = `+ ${this.formatMoney(Number(option.dataset.price) * Number(option.dataset.quantity))}`;
        const quantity = row.querySelector('[data-complementary-quantity]');
        quantity.textContent = quantity.textContent.replace(/\d+\s*$/, option.dataset.quantity);
      }
      this.updateTotal();
    }

    getItems() {
      return Array.from(this.querySelectorAll('[data-complementary-checkbox]:checked')).map((checkbox) => ({
        id: checkbox.dataset.variantId,
        quantity: Number(checkbox.dataset.quantity),
        price: Number(checkbox.dataset.price)
      }));
    }

    formatMoney(cents) {
      return new Intl.NumberFormat(this.dataset.locale, {
        style: 'currency', currency: this.dataset.currency
      }).format(cents / 100);
    }

    updateTotal() {
      const summary = this.querySelector('[data-complementary-summary]');
      if (!summary) return;
      const items = this.getItems();
      const form = this.scope.querySelector('product-form form');
      const quantity = Number(form?.elements.namedItem('quantity')?.value || 1);
      const price = this.scope.querySelector('[data-complementary-main-price]');
      const mainPrice = Number(price?.dataset.complementaryMainPrice ?? this.dataset.mainPrice);
      const total = mainPrice * quantity + items.reduce((sum, item) => sum + item.price * item.quantity, 0);
      summary.querySelector('[data-complementary-total]').textContent = this.formatMoney(total);
      summary.hidden = items.length === 0;
      this.querySelector('[data-complementary-note]').hidden = items.length === 0;
      this.toggleCheckout(items.length > 0);
    }

    toggleCheckout(selected) {
      const checkout = this.scope?.querySelector('.product-form__checkout');
      if (!checkout) return;
      if (selected && this.checkoutHidden === undefined) this.checkoutHidden = checkout.hidden;
      if (selected) checkout.hidden = true;
      else if (this.checkoutHidden !== undefined) {
        checkout.hidden = this.checkoutHidden;
        this.checkoutHidden = undefined;
      }
    }
  });
}
